var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 35,
    height: 35,
    rx: 6,
    fill: "url(#paint0_radial_161_67684)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 35,
    height: 35,
    rx: 6,
    fill: "url(#paint1_radial_161_67684)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 35,
    height: 35,
    rx: 6,
    fill: "url(#paint2_radial_161_67684)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 13.125C28.75 14.1605 27.9105 15 26.875 15C25.8395 15 25 14.1605 25 13.125C25 12.0895 25.8395 11.25 26.875 11.25C27.9105 11.25 28.75 12.0895 28.75 13.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 26.25C23.4518 26.25 26.25 23.4518 26.25 20C26.25 16.5482 23.4518 13.75 20 13.75C16.5482 13.75 13.75 16.5482 13.75 20C13.75 23.4518 16.5482 26.25 20 26.25ZM20 23.75C22.0711 23.75 23.75 22.0711 23.75 20C23.75 17.9289 22.0711 16.25 20 16.25C17.9289 16.25 16.25 17.9289 16.25 20C16.25 22.0711 17.9289 23.75 20 23.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 19.5C7.5 15.2996 7.5 13.1994 8.31745 11.5951C9.0365 10.1839 10.1839 9.0365 11.5951 8.31745C13.1994 7.5 15.2996 7.5 19.5 7.5H20.5C24.7004 7.5 26.8006 7.5 28.4049 8.31745C29.8161 9.0365 30.9635 10.1839 31.6825 11.5951C32.5 13.1994 32.5 15.2996 32.5 19.5V20.5C32.5 24.7004 32.5 26.8006 31.6825 28.4049C30.9635 29.8161 29.8161 30.9635 28.4049 31.6825C26.8006 32.5 24.7004 32.5 20.5 32.5H19.5C15.2996 32.5 13.1994 32.5 11.5951 31.6825C10.1839 30.9635 9.0365 29.8161 8.31745 28.4049C7.5 26.8006 7.5 24.7004 7.5 20.5V19.5ZM19.5 10H20.5C22.6414 10 24.0972 10.0019 25.2224 10.0939C26.3184 10.1834 26.879 10.3457 27.27 10.545C28.2108 11.0243 28.9757 11.7892 29.455 12.73C29.6543 13.121 29.8166 13.6816 29.9061 14.7776C29.9981 15.9028 30 17.3586 30 19.5V20.5C30 22.6414 29.9981 24.0972 29.9061 25.2224C29.8166 26.3184 29.6543 26.879 29.455 27.27C28.9757 28.2108 28.2108 28.9757 27.27 29.455C26.879 29.6543 26.3184 29.8166 25.2224 29.9061C24.0972 29.9981 22.6414 30 20.5 30H19.5C17.3586 30 15.9028 29.9981 14.7776 29.9061C13.6816 29.8166 13.121 29.6543 12.73 29.455C11.7892 28.9757 11.0243 28.2108 10.545 27.27C10.3457 26.879 10.1834 26.3184 10.0939 25.2224C10.0019 24.0972 10 22.6414 10 20.5V19.5C10 17.3586 10.0019 15.9028 10.0939 14.7776C10.1834 13.6816 10.3457 13.121 10.545 12.73C11.0243 11.7892 11.7892 11.0243 12.73 10.545C13.121 10.3457 13.6816 10.1834 14.7776 10.0939C15.9028 10.0019 17.3586 10 19.5 10Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_161_67684",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15 28.75) rotate(-55.3758) scale(31.8995)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_161_67684",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.75 38.75) rotate(-65.1363) scale(28.2428)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_161_67684",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.625002 3.75) rotate(-8.1301) scale(48.6136 10.3979)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramColored);
export default __webpack_public_path__ + "5db9642110e6c2493935498fcd838de1.svg";
export { ForwardRef as ReactComponent };